import { PRODUCT_ROW_NOTE, PRODUCTS_NOTE } from '../data/products';
import { iconSvg } from './icon';
import { escapeHtml, formatDate } from './util';

/** A strong callout: an icon, a bold lead and the words. */
function calloutHtml(kind: 'product' | 'paused', icon: string, lead: string, body: string, role = ''): string {
  return `<div class="callout callout--${kind}"${role ? ` role="${role}"` : ''}>
    ${iconSvg(icon, 18, 'callout-icon')}
    <p class="callout-text"><strong>${escapeHtml(lead)}</strong> ${escapeHtml(body)}</p>
  </div>`;
}

/** Heads the Products view. */
export function productsCalloutHtml(): string {
  return calloutHtml('product', 'hammer', PRODUCTS_NOTE.title, PRODUCTS_NOTE.body);
}

/** In a product's expanded row. */
export function productCalloutHtml(): string {
  return `<div class="callout callout--product callout--row">
    ${iconSvg('hammer', 16, 'callout-icon')}
    <p class="callout-text"><strong>${escapeHtml(PRODUCT_ROW_NOTE)}</strong></p>
  </div>`;
}

/** Says the experiment is paused on purpose, so a quiet directory doesn't read as abandoned. */
export function pauseNoticeHtml(lastRun: string): string {
  return calloutHtml(
    'paused',
    'circle-pause',
    'The daily experiment is paused.',
    `It's intentional: the factories last ran on ${formatDate(lastRun)} and may resume soon.`,
    'status',
  );
}
